import {createSelector, createSlice} from "@reduxjs/toolkit";
import {customerTypeName} from "./customerData";

const initialCustomerState = {
  customers: [],
  providers: [],
  selectedCustomer: undefined,
  init: false
};


export const customerSlice = createSlice({
  name: "customer",
  initialState: initialCustomerState,
  reducers: {
    // listProducts
    setCustomers: (state, action) => {
      state.customers = action.payload;
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setProviders: (state, action) => {
      state.providers = action.payload;
    },
    resetCustomers: (state) => {
      state.customers = []
    },
    resetSelectedCustomer: (state, action) => {
      state.selectedCustomer = undefined;
    },
    setInit: (state) => {
      state.init = true;
    }
  }
});

export const {setCustomers, setSelectedCustomer, setProviders, resetCustomers, resetSelectedCustomer, setInit} = customerSlice.actions;

export const selectCustomers = (state) => state.customer.customers;
export const selectProviders = (state) => state.customer.providers;
export const selectSelectedCustomer = (state) => state.customer.selectedCustomer;
export const selectIsPharmacy = createSelector(selectSelectedCustomer, (customer) => customerTypeName.pharmacy === customer?.type)
export const selectInit = (state) => state.customer.init;


